module.exports = __webpack_public_path__ + "img/shequyanglao_image_ylams.88c1800e.png";